'use client';
import { ComponentType, lazy } from 'react';
import BrandsPlaceholderComponent from './brands-placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './brands.component';
import dynamic from 'next/dynamic';
import lazyAndDynamicComponentFactory from '@spa/components/lazy-and-dynamic/lazyAndDynamicComponentFactory';

const DynamicBrandsComponent: ComponentType<Props> = dynamic(() => import('./brands.component'));
const LazyBrandsComponent: ComponentType<Props> = lazy(() => import('./brands.component'));

export default lazyAndDynamicComponentFactory(
  calculateBrandsPlaceholderConfig,
  LazyBrandsComponent,
  DynamicBrandsComponent
);

export function calculateBrandsPlaceholderConfig(props: Props): PlaceholderConfig {
  return {
    content: <BrandsPlaceholderComponent {...props} />,
    heightSinceWidth: [{ sinceWidth: 0, height: 100 }]
  };
}
